export class HashGen {
    static regular(pattern) {
        return (pattern || 'xxyyyxxyyy').replace(/[xy]/g, c => {
            let chars = 'abcdefghijklmnopqrstuvwxyz';
            let digits = '0123456789';
            return c === 'x'
                ? chars.charAt(Math.floor(Math.random() * chars.length))
                : digits.charAt(Math.floor(Math.random() * digits.length));
        });
    }
    /**
     * Hashes of the records that pile up with sales — orders, order items,
     * kitchen tickets and their items, payment sessions, table sessions,
     * delivery tickets: a letter, then 12 of
     * [a-z0-9] — 26·36¹² (~1.2e20) values against regular()'s 26⁴·10⁶
     * (~4.6e11), which repeats within a venue's first few hundred thousand. Lowercase only: the
     * tenant DB compares hashes case-insensitively. The leading letter keeps a
     * hash from ever reading as a number (PHP compares numeric strings as
     * numbers). regular() keeps its 'ab123cd456' shape: venue, operator and
     * cash-register codes fall back to it, and on me those are EFI codes,
     * which EFI accepts only in that shape.
     */
    static long() {
        const letters = 'abcdefghijklmnopqrstuvwxyz';
        const chars = letters + '0123456789';
        const pick = (set) => set.charAt(Math.floor(Math.random() * set.length));
        let hash = pick(letters);
        for (let i = 0; i < 12; i++)
            hash += pick(chars);
        return hash;
    }
    static double() {
        return HashGen.regular() + HashGen.regular();
    }
    static uuid4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = Math.random() * 16 | 0;
            let v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}
export default HashGen;
//# sourceMappingURL=HashGen.js.map